import { render, staticRenderFns } from "./ProfileDeleted.vue?vue&type=template&id=2246efcb&scoped=true"
import script from "./ProfileDeleted.vue?vue&type=script&lang=js"
export * from "./ProfileDeleted.vue?vue&type=script&lang=js"
import style0 from "./ProfileDeleted.vue?vue&type=style&index=0&id=2246efcb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2246efcb",
  null
  
)

export default component.exports